export default __webpack_public_path__ + "static/media/custom2.ceb6f4c5.png";